import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab, { TabProps } from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { useMediaQuery } from 'react-responsive';

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ py: 3 }}>{children}</Box>}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export default function BasicTabs({
    tabNames,
    tabs,
    activeTab,
    setActiveTab,
}: {
    tabNames: TabProps['label'][];
    tabs: React.ReactNode[];
    activeTab: number;
    setActiveTab: React.Dispatch<React.SetStateAction<number>>;
}) {
    const isMobile = useMediaQuery({
        query: '(max-width: 768px)',
    });

    const handleChange = (_: React.SyntheticEvent, newValue: number) => {
        setActiveTab(newValue);
    };

    const tabWidth = isMobile ? `calc(100% / ${tabNames.length})` : 'inherit';

    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs
                    value={activeTab}
                    onChange={handleChange}
                    aria-label="basic tabs"
                    sx={{
                        '& .MuiTabs-indicator': {
                            backgroundColor: 'var(--app-primary, #2878d4)',
                        },
                    }}
                >
                    {tabNames.map((tab) => (
                        <Tab
                            key={tab?.toString()}
                            label={tab}
                            {...a11yProps(0)}
                            sx={{
                                width: tabWidth,
                                color: 'var(--app-primary, #2878d4)',
                                '&.Mui-selected': {
                                    color: 'var(--app-primary, #2878d4)',
                                },
                            }}
                        />
                    ))}
                </Tabs>
            </Box>
            {tabs.map((tab, index) => (
                <CustomTabPanel value={activeTab} index={index} key={index}>
                    {tab}
                </CustomTabPanel>
            ))}
        </Box>
    );
}
